import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Button, Checkbox, Flex, Stack, Table, TableContainer, Text, useToast } from '@chakra-ui/react';
import { MdRefresh } from '@react-icons/all-files/md/MdRefresh';
import { getCoreRowModel, getFacetedUniqueValues, getFilteredRowModel, getPaginationRowModel, useReactTable } from '@tanstack/react-table';
import { useEffect, useMemo, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { Mode, TableActionType } from 'src/types/crudTable';
import dataTestID from '../../../constants/DataTestIndex';
import { fuzzyFilter, generateStatusMessage, getColumnPinning, getInitTableData, handleBulkUpdates } from '../utils';
import { EditHelper } from './EditHeler';
import { EditableCell } from './EditableCell';
import { LoadingBar } from './LoadingBar';
import { TableBody } from './TableBody';
import { TableFooter } from './TableFooter';
import { TableHeader } from './TableHeader';
import { tableReducer } from './tableReducer';
import { TableContext, useTableContext } from './useTableContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var EditButton = function EditButton(_ref) {
  var isDisabled = _ref.isDisabled;

  var _useTableContext = useTableContext(),
      mode = _useTableContext.mode,
      setMode = _useTableContext.setMode;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Button, {
    variant: "outline",
    onClick: function onClick() {
      return setMode(mode === Mode.VIEW ? Mode.EDIT : Mode.VIEW);
    },
    isDisabled: isDisabled,
    e2eid: "CrudTable_index_Button",
    children: mode === Mode.VIEW ? t('common:button.toEditMode', '進入編輯模式') : t('common:button.cancel', '取消')
  });
};

var SaveButton = function SaveButton(_ref2) {
  var onSave = _ref2.onSave,
      isLoading = _ref2.isLoading;

  var _useTableContext2 = useTableContext(),
      changes = _useTableContext2.changes,
      mode = _useTableContext2.mode;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  if (mode !== Mode.EDIT) {
    return;
  }

  var isDisabled = Object.keys(changes).length === 0;
  return /*#__PURE__*/_jsx(Button, {
    leftIcon: /*#__PURE__*/_jsx(MdRefresh, {
      size: "1.1rem",
      e2eid: "CrudTable_index_MdRefresh"
    }),
    onClick: onSave,
    isDisabled: isDisabled,
    isLoading: isLoading,
    e2eid: "CrudTable_index_Button_1",
    children: t('common:button.saveAndExitEditMode', '儲存並離開編輯模式')
  });
};

var HeadCheckbox = function HeadCheckbox(_ref3) {
  var table = _ref3.table;

  var _useTableContext3 = useTableContext(),
      mode = _useTableContext3.mode;

  return /*#__PURE__*/_jsx(Checkbox, {
    isChecked: table.getIsAllPageRowsSelected(),
    isIndeterminate: table.getIsSomePageRowsSelected(),
    onChange: table.getToggleAllPageRowsSelectedHandler(),
    isDisabled: mode !== Mode.EDIT,
    e2eid: "CrudTable_index_Checkbox"
  });
};

var BodyCheckbox = function BodyCheckbox(_ref4) {
  var row = _ref4.row;

  var _useTableContext4 = useTableContext(),
      mode = _useTableContext4.mode;

  return /*#__PURE__*/_jsx(Checkbox, {
    isChecked: row.getIsSelected(),
    onChange: row.getToggleSelectedHandler(),
    isDisabled: mode !== Mode.EDIT,
    e2eid: "CrudTable_index_Checkbox_4"
  });
};

var checkboxColumnDef = {
  id: 'select',
  size: 24,
  width: '24px',
  enableSorting: false,
  enableGlobalFilter: false,
  enableColumnFilter: false,
  header: function header(_ref5) {
    var table = _ref5.table;
    return /*#__PURE__*/_jsx(Flex, {
      justify: "center",
      align: "center",
      w: "full",
      e2eid: "CrudTable_index_Flex",
      children: /*#__PURE__*/_jsx(HeadCheckbox, {
        table: table,
        e2eid: "CrudTable_index_HeadCheckbox"
      })
    });
  },
  cell: function cell(_ref6) {
    var row = _ref6.row;
    return /*#__PURE__*/_jsx(Flex, {
      justify: "center",
      align: "center",
      e2eid: "CrudTable_index_Flex",
      children: /*#__PURE__*/_jsx(BodyCheckbox, {
        row: row,
        e2eid: "CrudTable_index_BodyCheckbox"
      })
    });
  }
};
/**
 * CrudTable Rules:
 * 1. columnDef.accessorKey must be equal to id
 * 2. when columnDef.meta.editable is truthy, cell will be editable, and cell will be rendered by EditableCell, default to Input
 * 3. when columnDef.meta.editable.options is an array, cell will be editable with select
 * 4. when columnDef.meta.bulkUpdate is truthy, cell will be bulk updatable, current only support select, see below
 * 5. when columnDef.meta.bulkUpdate.options is an array, cell will be bulk updatable with select
 * 6. onSave will be called with changes when save button clicked
 * 7. row.index will be used as id/key for each row
 */

export var CrudTable = function CrudTable(_ref7) {
  var _ref7$pageSize = _ref7.pageSize,
      pageSize = _ref7$pageSize === void 0 ? 15 : _ref7$pageSize,
      _ref7$colorScheme = _ref7.colorScheme,
      colorScheme = _ref7$colorScheme === void 0 ? 'brandScheme' : _ref7$colorScheme,
      _ref7$columnVisibilit = _ref7.columnVisibility,
      columnVisibility = _ref7$columnVisibilit === void 0 ? {} : _ref7$columnVisibilit,
      _ref7$editable = _ref7.editable,
      editable = _ref7$editable === void 0 ? true : _ref7$editable,
      getBulkUpdates = _ref7.getBulkUpdates,
      _ref7$loading = _ref7.loading,
      loading = _ref7$loading === void 0 ? false : _ref7$loading,
      columns = _ref7.columns,
      data = _ref7.data,
      _ref7$stickyColumns = _ref7.stickyColumns,
      stickyColumns = _ref7$stickyColumns === void 0 ? {
    right: [],
    left: []
  } : _ref7$stickyColumns,
      handlers = _ref7.handlers,
      customToolbar = _ref7.customToolbar,
      customActions = _ref7.customActions,
      maxH = _ref7.maxH;

  var _useReducer = useReducer(tableReducer, {
    mode: Mode.VIEW,
    data: getInitTableData(data),
    originalData: data !== null && data !== void 0 ? data : [],
    changes: {},
    selection: {},
    columnFilters: [],
    pagination: {
      pageIndex: 0,
      pageSize: pageSize
    },
    saving: false
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var columnPinning = useMemo(function () {
    return getColumnPinning(columns, stickyColumns);
  }, [columns, stickyColumns]);

  var _columns = useMemo(function () {
    return [checkboxColumnDef].concat(_toConsumableArray(columns.map(function (column) {
      var _column$meta;

      return _objectSpread(_objectSpread({}, column), {}, {
        cell: (_column$meta = column.meta) !== null && _column$meta !== void 0 && _column$meta.editable && editable ? function (props) {
          return /*#__PURE__*/_jsx(EditableCell, _objectSpread(_objectSpread({}, props), {}, {
            originalCell: column.cell,
            e2eid: "CrudTable_index_EditableCell"
          }));
        } : column.cell
      });
    })));
  }, [columns, editable]);

  var _columnVisibility = useMemo(function () {
    return _objectSpread(_objectSpread({}, columnVisibility), {}, {
      select: state.mode !== Mode.VIEW
    });
  }, [state.mode, columnVisibility]);

  var _useTranslation3 = useTranslation(),
      t = _useTranslation3.t;

  var toast = useToast({
    containerStyle: {
      maxWidth: '800px'
    }
  });
  var table = useReactTable({
    columns: _columns,
    data: state.data,
    filterFns: {
      fuzzy: fuzzyFilter
    },
    initialState: {
      columnPinning: columnPinning
    },
    state: {
      columnVisibility: _columnVisibility,
      rowSelection: state.selection,
      pagination: state.pagination,
      columnFilters: state.columnFilters
    },
    meta: {},
    enableColumnFilters: true,
    enableRowSelection: true,
    enableMultiRowSelection: true,
    enableSorting: false,
    onRowSelectionChange: function onRowSelectionChange(updater) {
      dispatch({
        type: TableActionType.SET_SELECTION,
        payload: updater(state.selection)
      });
    },
    onColumnFiltersChange: function onColumnFiltersChange(updater) {
      dispatch({
        type: TableActionType.SET_COLUMN_FILTERS,
        payload: updater(state.columnFilters)
      });
    },
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    autoResetPageIndex: false
  }); // set to last page when filter change and current page index is out of range

  useEffect(function () {
    var totalPage = Math.max(table.getPageCount(), 1);

    if (state.pagination.pageIndex >= totalPage) {
      dispatch({
        type: TableActionType.SET_PAGE,
        payload: Math.max(totalPage - 1, 0)
      });
    }
  }, [table, state.columnFilters, state.pagination.pageIndex]);
  useEffect(function () {
    if (data) {
      dispatch({
        type: TableActionType.RESET_DATA,
        payload: data
      });
    }
  }, [data]);

  var bulkUpdatesSaveHandler = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _getBulkUpdates, promises, records, bulkUpdateResults, isFullyFailed, isFullySuccessful, messageConfig, toastConfig, isReset, _yield$handlers$handl, _handlers$handleUpdat, _yield$handlers$handl2, _handlers$handleUpdat2, _yield$handlers$handl3, _handlers$handleUpdat3;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (getBulkUpdates) {
                _context.next = 3;
                break;
              }

              console.error('getBulkUpdates is required');
              return _context.abrupt("return");

            case 3:
              dispatch({
                type: TableActionType.ON_SAVING
              });
              _getBulkUpdates = getBulkUpdates(state.changes), promises = _getBulkUpdates.promises, records = _getBulkUpdates.records;
              _context.next = 7;
              return handleBulkUpdates(promises);

            case 7:
              bulkUpdateResults = _context.sent;
              isFullyFailed = bulkUpdateResults.isFullyFailed, isFullySuccessful = bulkUpdateResults.isFullySuccessful;
              messageConfig = generateStatusMessage(records, bulkUpdateResults, t);
              toastConfig = _objectSpread(_objectSpread({}, messageConfig), {}, {
                description: messageConfig.description && /*#__PURE__*/_jsx(Text, {
                  mt: 3,
                  whiteSpace: "pre-line",
                  color: "white",
                  fontFamily: "monospace",
                  e2eid: "CrudTable_index_Text",
                  children: messageConfig.description
                }),
                duration: isFullySuccessful ? 3000 : null,
                isClosable: true,
                position: 'top'
              });
              toast(toastConfig);

              if (!isFullyFailed) {
                _context.next = 28;
                break;
              }

              console.error('全部儲存失敗', bulkUpdateResults.errors);
              _context.next = 16;
              return handlers === null || handlers === void 0 ? void 0 : (_handlers$handleUpdat = handlers.handleUpdatesAllFailure) === null || _handlers$handleUpdat === void 0 ? void 0 : _handlers$handleUpdat.call(handlers, bulkUpdateResults.errors);

            case 16:
              _context.t1 = _yield$handlers$handl = _context.sent;
              _context.t0 = _context.t1 !== null;

              if (!_context.t0) {
                _context.next = 20;
                break;
              }

              _context.t0 = _yield$handlers$handl !== void 0;

            case 20:
              if (!_context.t0) {
                _context.next = 24;
                break;
              }

              _context.t2 = _yield$handlers$handl;
              _context.next = 25;
              break;

            case 24:
              _context.t2 = false;

            case 25:
              isReset = _context.t2;
              _context.next = 56;
              break;

            case 28:
              if (!isFullySuccessful) {
                _context.next = 43;
                break;
              }

              _context.next = 31;
              return handlers === null || handlers === void 0 ? void 0 : (_handlers$handleUpdat2 = handlers.handleUpdatesAllSuccess) === null || _handlers$handleUpdat2 === void 0 ? void 0 : _handlers$handleUpdat2.call(handlers);

            case 31:
              _context.t4 = _yield$handlers$handl2 = _context.sent;
              _context.t3 = _context.t4 !== null;

              if (!_context.t3) {
                _context.next = 35;
                break;
              }

              _context.t3 = _yield$handlers$handl2 !== void 0;

            case 35:
              if (!_context.t3) {
                _context.next = 39;
                break;
              }

              _context.t5 = _yield$handlers$handl2;
              _context.next = 40;
              break;

            case 39:
              _context.t5 = true;

            case 40:
              isReset = _context.t5;
              _context.next = 56;
              break;

            case 43:
              console.error('部分儲存失敗', bulkUpdateResults.errors);
              _context.next = 46;
              return handlers === null || handlers === void 0 ? void 0 : (_handlers$handleUpdat3 = handlers.handleUpdatesPartialSuccess) === null || _handlers$handleUpdat3 === void 0 ? void 0 : _handlers$handleUpdat3.call(handlers, bulkUpdateResults.errors);

            case 46:
              _context.t7 = _yield$handlers$handl3 = _context.sent;
              _context.t6 = _context.t7 !== null;

              if (!_context.t6) {
                _context.next = 50;
                break;
              }

              _context.t6 = _yield$handlers$handl3 !== void 0;

            case 50:
              if (!_context.t6) {
                _context.next = 54;
                break;
              }

              _context.t8 = _yield$handlers$handl3;
              _context.next = 55;
              break;

            case 54:
              _context.t8 = true;

            case 55:
              isReset = _context.t8;

            case 56:
              if (isReset) {
                dispatch({
                  type: TableActionType.RESET
                });
              } else {
                dispatch({
                  type: TableActionType.ON_SAVED
                });
              }

            case 57:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function bulkUpdatesSaveHandler() {
      return _ref8.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(TableContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch,
      table: table
    },
    children: /*#__PURE__*/_jsxs(Stack, {
      overflow: "auto",
      rounded: "md",
      w: "full",
      h: "full",
      maxH: maxH,
      bgColor: "white",
      spacing: 0,
      e2eid: "CrudTable_index_Stack",
      children: [/*#__PURE__*/_jsxs(Flex, {
        justify: "space-between",
        align: "center",
        py: 2,
        gap: 2,
        e2eid: "CrudTable_index_Flex",
        children: [/*#__PURE__*/_jsx(Box, {
          e2eid: "CrudTable_index_Box",
          children: customToolbar
        }), /*#__PURE__*/_jsxs(Flex, {
          gap: 2,
          e2eid: "CrudTable_index_Flex",
          children: [editable && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(EditButton, {
              isDisabled: state.saving,
              e2eid: "CrudTable_index_EditButton"
            }), /*#__PURE__*/_jsx(SaveButton, {
              onSave: bulkUpdatesSaveHandler,
              isLoading: state.saving,
              e2eid: "CrudTable_index_SaveButton"
            })]
          }), customActions]
        })]
      }), /*#__PURE__*/_jsx(EditHelper, {
        e2eid: "CrudTable_index_EditHelper"
      }), /*#__PURE__*/_jsxs(Box, {
        overflow: loading ? 'hidden' : 'auto',
        position: "relative",
        w: "full",
        e2eid: "CrudTable_index_Box",
        children: [(loading || state.saving) && /*#__PURE__*/_jsx(LoadingBar, {
          e2eid: "CrudTable_index_LoadingBar"
        }), /*#__PURE__*/_jsx(TableContainer, {
          position: "relative",
          rounded: "md",
          overflowY: "initial",
          overflow: "initial",
          borderWidth: 1,
          borderColor: "gray.300",
          e2eid: "CrudTable_index_TableContainer",
          children: /*#__PURE__*/_jsxs(Table, {
            "data-test": dataTestID.generalTable.Table,
            layout: "fixed",
            variant: "medicine",
            colorScheme: colorScheme,
            maxW: "100%",
            bgColor: "white",
            shadow: " 0px 4px 24px rgba(65, 29, 29, 0.06)",
            w: "100%",
            style: {
              borderCollapse: 'separate',
              borderSpacing: 0
            },
            e2eid: "CrudTable_index_Table",
            children: [/*#__PURE__*/_jsx(TableHeader, {
              isDisabled: state.saving,
              e2eid: "CrudTable_index_TableHeader"
            }), /*#__PURE__*/_jsx(TableBody, {
              isDisabled: state.saving,
              e2eid: "CrudTable_index_TableBody"
            })]
          })
        })]
      }), /*#__PURE__*/_jsx(TableFooter, {
        colorScheme: colorScheme,
        e2eid: "CrudTable_index_TableFooter"
      })]
    })
  });
};